<template>
  <div class="home">
    <Head />
    <MapGIS mapKey="bdmap"/>
  </div>
</template>

<script>
// @ is an alias to /src
import MapGIS from '@/components/GIS-map/Main.vue'
import Head from '@/components/Head/index.vue'
export default {
  name: 'HomeView',
  components: {
    Head,
    MapGIS
  },
  mounted() {
    this.$bus.$emit("grid-change", true);
  },
}
</script>
